
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.634 0H7.933C3.99 0 .783 3.207.783 7.15v9.7c0 3.943 3.208 7.15 7.15 7.15h9.7c3.943 0 7.15-3.207 7.15-7.15v-9.7c0-3.943-3.207-7.15-7.15-7.15zm4.735 16.85a4.735 4.735 0 01-4.735 4.736H7.933a4.735 4.735 0 01-4.735-4.736v-9.7a4.735 4.735 0 014.735-4.736h9.7A4.735 4.735 0 0122.37 7.15v9.7z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.785 5.793A6.214 6.214 0 006.578 12a6.214 6.214 0 006.207 6.207A6.214 6.214 0 0018.993 12a6.214 6.214 0 00-6.208-6.207zm0 10a3.793 3.793 0 110-7.586 3.793 3.793 0 010 7.586zM19.003 7.327a1.487 1.487 0 100-2.975 1.487 1.487 0 000 2.975z","fill":"currentColor"}})])
          )
        }
      }
    